// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoPanel_container__1Zsbd","title":"InfoPanel_title__3-aOR","expanded":"InfoPanel_expanded__EZ5Ap","content":"InfoPanel_content__2jmyz"};